export default __webpack_public_path__ + "BackgroundHome.55a0ab3.jpg";